import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserRole } from '../Models/Common/UserRole';
import { Global } from '../Shared/global';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiUrl = Global.BASE_USER_ENDPOINT() + 'user';

  constructor(private http: HttpClient) { }

  /**
   * Get all active roles
   */
  getRoles(): Observable<UserRole[]> {
    return this.http.get<UserRole[]>(`${this.apiUrl}/GetUserData?id=0&datatype=role`).pipe(
      catchError(error => {
        Global.LogError('Failed to fetch roles:', error);
        return throwError(() => error);
      })
    );
  }
}
